import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { BlockConnector } from './BlockConnector';
import { useBlockContext } from './BlockContext';
import { evaluateCondition } from './conditionalRules';
import { createContractDataAccessor } from './createContractDataLocator';
import { ParameterTemplate } from './ParameterTemplate';
import { useContracts } from './useContracts';
import { jsx as _jsx } from "react/jsx-runtime";
export function useZoneConfiguration(_ref) {
  var zoneType = _ref.zoneType,
    zoneContractData = _ref.zoneContractData;
  var _useBlockContext = useBlockContext(),
    block = _useBlockContext.block,
    view = _useBlockContext.view;
  var contracts = useContracts(zoneContractData);
  var baseZones = view.zones;
  var blocks = view.blocks;
  var currentZoneRIDs = block.zoneRIDs;
  return React.useMemo(function () {
    var zonesToRender = baseZones === null || baseZones === void 0 ? void 0 : baseZones.filter(function (x) {
      return x.zoneRID && x.zoneType === zoneType && (currentZoneRIDs === null || currentZoneRIDs === void 0 ? void 0 : currentZoneRIDs.includes(x.zoneRID));
    });
    if (!zonesToRender || !zonesToRender.length) {
      // can early return empty content since view.zones was null
      return [];
    }
    var zoneInstances = [];
    var upstreamContracts = contracts !== null && contracts !== void 0 ? contracts : [];
    var getContractDataAt = createContractDataAccessor(upstreamContracts);
    var _iterator = _createForOfIteratorHelper(zonesToRender),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var zoneToRender = _step.value;
        if (!!zoneToRender.condition && !evaluateCondition(upstreamContracts, zoneToRender.condition)) {
          // skip over this node since it will not be rendered
          continue;
        }
        var iteratedZones = [];
        if (zoneToRender.foreach && zoneToRender.as) {
          var contractDataValue = getContractDataAt(zoneToRender.foreach);
          if (isIterable(contractDataValue)) {
            var iterableValues = contractDataValue;
            var _iterator2 = _createForOfIteratorHelper(iterableValues),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var itemValue = _step2.value;
                iteratedZones.push({
                  zone: mapToKeyedZoneType(zoneToRender, iteratedZones.length),
                  mappedContract: _objectSpread(_objectSpread({}, zoneContractData), {}, _defineProperty({}, zoneToRender.as, itemValue))
                });
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            console.warn("Attempting to iterate over a non-iterable value at ".concat(zoneToRender.foreach, "."));
          }
        } else {
          iteratedZones.push({
            zone: mapToKeyedZoneType(zoneToRender, iteratedZones.length),
            mappedContract: zoneContractData
          });
        }
        for (var _i = 0, _iteratedZones = iteratedZones; _i < _iteratedZones.length; _i++) {
          var zoneIteration = _iteratedZones[_i];
          var zone = zoneIteration.zone,
            mappedContract = zoneIteration.mappedContract;
          var contractSourcesForReplacement = mappedContract ? upstreamContracts.concat([mappedContract]) : upstreamContracts;
          var zoneParameters = zone.zoneParameters;
          if (zoneParameters) {
            zoneParameters = ParameterTemplate.replace.apply(ParameterTemplate, [zoneParameters].concat(_toConsumableArray(contractSourcesForReplacement)));
          }
          var blocksInZone = expandIterableBlocks(zone.zoneRID, blocks, getContractDataAt, mappedContract);
          zoneInstances.push({
            zone: _objectSpread(_objectSpread({}, zone), {}, {
              zoneParameters: zoneParameters
            }),
            children: blocksInZone
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return zoneInstances;
  }, [zoneType, baseZones, currentZoneRIDs, blocks, zoneContractData, contracts]);
}
function isIterable(value) {
  return _typeof(value) === 'object' && value !== null && (Array.isArray(value) || typeof value[Symbol.iterator] === 'function');
}
function mapToKeyedZoneType(zone) {
  var _zone$zoneRID;
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return _objectSpread(_objectSpread({}, zone), {}, {
    key: "".concat((_zone$zoneRID = zone.zoneRID) !== null && _zone$zoneRID !== void 0 ? _zone$zoneRID : zone.zoneType, "#").concat(index)
  });
}
function expandIterableBlocks(zoneRID, blocks, contractDataAccessor, zoneContractData) {
  var iteratedBlocks = [];
  var _iterator3 = _createForOfIteratorHelper(blocks),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var block = _step3.value;
      if (block.parentZoneRID !== zoneRID) {
        // skip this instance
        continue;
      }
      if (block.foreach && block.as) {
        var contractDataValue = contractDataAccessor(block.foreach);
        if (isIterable(contractDataValue)) {
          var iterableValues = contractDataValue;
          var _iterator4 = _createForOfIteratorHelper(iterableValues),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var itemValue = _step4.value;
              iteratedBlocks.push({
                block: mapToKeyedBlockType(block, iteratedBlocks.length),
                mappedContract: _objectSpread(_objectSpread({}, zoneContractData), {}, _defineProperty({}, block.as, itemValue))
              });
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } else {
          console.warn("Attempting to iterate over a non-iterable value at ".concat(block.foreach, "."));
        }
      } else {
        iteratedBlocks.push({
          block: mapToKeyedBlockType(block, iteratedBlocks.length),
          mappedContract: zoneContractData
        });
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return iteratedBlocks.map(function (x) {
    var _x$block$key;
    return /*#__PURE__*/_jsx(BlockConnector, {
      block: x.block,
      contractData: x.mappedContract
    }, (_x$block$key = x.block.key) !== null && _x$block$key !== void 0 ? _x$block$key : x.block.blockRID);
  });
}
function mapToKeyedBlockType(block) {
  var _block$blockRID;
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return _objectSpread(_objectSpread({}, block), {}, {
    key: "".concat((_block$blockRID = block.blockRID) !== null && _block$blockRID !== void 0 ? _block$blockRID : block.blockName, "#").concat(index)
  });
}